import moment from 'moment';
import { environment } from 'environments';
import { firstValueFrom } from 'rxjs';

(() => {
  class ChargeMailOrderRefillController {
    constructor(
      $rootScope,
      $scope,
      $timeout,
      $interval,
      toastr,
      Orders,
      Users,
      $state,
      ngDialog,
      Utils,
      RefillResponsesStoreStore,
      FillsEndpoints,
    ) {
      'ngInject';

      Object.assign(this, {
        $scope,
        $rootScope,
        $timeout,
        $interval,
        toastr,
        Orders,
        Users,
        $state,
        ngDialog,
        Utils,
        visit: $scope.ngDialogData.visit,
        showFillCharged: '1 fill',
        showFillSent: '1 fill',
        prescription: $scope.ngDialogData.prescription,
        membershipDiscount: $scope.ngDialogData.membershipDiscount,
        charging: false,
        RefillResponsesStoreStore,
        FillsEndpoints,
        fillCharged: [
          {
            id: '1',
            name: '1 fill',
          },
        ],
        fillSent: [
          {
            id: '1',
            name: '1 fill',
          },
        ],
        isRecurring: false,
        timezone: $rootScope.timezones[0].timezone,
      });
      this.mail_order_original = angular.copy(this.prescription.mail_order); // WE WILL KEEP "refillDate" AS DATE WITHOUT TIME
      // ALSO THE "DATE PICKER" IS RETURNING A DATE TYPE
      // this.refillDate = moment().format('MM-DD-YYYY');

      if (
        this.prescription.mail_order.recurring_discount_amount &&
        this.prescription.mail_order.recurring_discount_amount > 0
      ) {
        this.isRecurring = true;
      }

      this.refillDate = new Date(); // this.refillDate.setHours(0,0,0,0);

      this.medName = this.prescription.code;
      this.autoRefillOptions = [
        {
          id: '0',
          value: false,
          name: 'One Time',
        },
        {
          id: '1',
          value: true,
          name: 'Auto Delivery',
        },
      ];

      if (this.prescription.mail_order && this.prescription.mail_order.auto_refill) {
        this.option_selected = '1';
      } else {
        this.option_selected = '0';
      }

      this.getMailOrderPayment();
    }

    getMailOrderPayment() {
      this.fillCharged.forEach(m => {
        if (m.name === this.showFillCharged) {
          this.noOfRefillCharged = m.id;
        }
      });
      this.fillSent.forEach(m => {
        if (m.name === this.showFillSent) {
          this.noOfRefillSent = m.id;
        }
      });

      let basePrice = this.prescription.dispense_amount * this.prescription.unit_price * this.noOfRefillCharged;

      if (
        this.prescription.mail_order.recurring_discount_amount &&
        this.prescription.mail_order.recurring_discount_amount > 0
      ) {
        basePrice = basePrice - this.noOfRefillCharged * this.prescription.mail_order.recurring_discount_amount;
      }
      if (this.membershipDiscount && this.membershipDiscount > 0) {
        this.medicationFee = basePrice * (1 - this.membershipDiscount);
      } else {
        this.medicationFee = basePrice;
      }
    }

    close() {
      this.$scope.closeThisDialog(false);
    }

    medicationCharge() {
      var this2 = this;

      if (this.noOfRefillSent < this.noOfRefillCharged) {
        this.toastr.error('Number of refills to send is less than the number of refills to be charged ');
        return;
      } // WE WILL KEEP "refillDate" AS DATE WITHOUT TIME
      // ALSO THE "DATE PICKER" IS RETURNING A DATE TYPE
      // this.refillDate.setHours(0,0,0,0);

      const isAutoDelivery = this.option_selected == '1';
      const daysBetween = parseInt(this.prescription.mail_order.days_between_refills, 10);
      if (isAutoDelivery && (!daysBetween || daysBetween < 1 || daysBetween > 365)) {
        this.toastr.error('Please enter how many days between refills');
        return;
      }

      this.refill_Date = moment(this.refillDate).toISOString();

      if (isNaN(this.medicationFee)) {
        this.medicationFee = this.medicationFee.replace('£', '');
      }

      this.chargeData = {
        amount: this.medicationFee,
      };

      if (this.option_selected == '1') {
        this.auto_refill_option_selected = true;
      } else {
        this.auto_refill_option_selected = false;
      }

      var mail_order_id = this.prescription.mail_order.id;
      this.processing = true;

      const daysBetweenChanged =
        isAutoDelivery && daysBetween !== parseInt(this.mail_order_original.days_between_refills, 10);

      const proceedToPayment = () => {
        const deliveryPayload = { auto_refill: this.auto_refill_option_selected };
        if (this.mail_order_original.auto_refill != this.auto_refill_option_selected) {
          this.Orders.updateMailorderDeliveryType(mail_order_id, deliveryPayload)
            .then(({ data }) => {
              this2.processFillRequestPayment(mail_order_id, this2.chargeData, this2.refill_Date);
            })
            .catch(err => {
              this2.toastr.error('Error updating the mailorder auto refill setting: ' + JSON.stringify(err));
              this2.processing = false;
              this2.$scope.closeThisDialog(false);
            });
        } else {
          this2.processFillRequestPayment(mail_order_id, this2.chargeData, this2.refill_Date);
        }
      };

      if (daysBetweenChanged) {
        const refillInfo = {
          auto_refill: this.mail_order_original.auto_refill,
          refills_remaining: parseInt(this.prescription.mail_order.refills_remaining, 10),
          days_between_refills: daysBetween,
        };
        this.Orders.updateRefillInfo(mail_order_id, refillInfo)
          .then(() => {
            proceedToPayment();
          })
          .catch(err => {
            const errMsg = err?.data?.message?.summary || err?.status || JSON.stringify(err);
            this2.toastr.error('Error updating days between refills: ' + errMsg);
            this2.processing = false;
          });
      } else {
        proceedToPayment();
      }
    }

    processFillRequestPayment(mail_order_id, chargeData, refill_Date) {
      var this2 = this;
      const hasOpenRefill = this.RefillResponsesStoreStore.openRefillResponse().hasOpenRefill;
      const payload = hasOpenRefill
        ? { response_id: this.RefillResponsesStoreStore.openRefillResponse().responseId }
        : {};
      firstValueFrom(this.FillsEndpoints.post(mail_order_id, payload))
        .then(result => ({ data: result }))
        .then(({ data }) => {
          var fill_id = data.id;
          var fillDetail = {
            fill_date: this2.Utils.formatDateToISO(refill_Date, this2.timezone),
            num_to_charge: this2.noOfRefillCharged,
            num_to_send: this2.noOfRefillSent,
            ...chargeData,
          };
          this2.Orders.updateMailorderFill(mail_order_id, fill_id, fillDetail)
            .then(({ data }) => {
              this2.toastr.success('Payment and Fill Request will be processed on ' + refill_Date);
              this2.processing = false;
              this2.$scope.closeThisDialog(true);
            })
            .catch(err => {
              this2.toastr.error(`Error updating the mailorder fills: ${err.data.message} `);
              this2.processing = false;
              this2.$scope.closeThisDialog(false);
            });
        })
        .catch(err => {
          this2.toastr.error('Error creating the mailorder fills: ' + err.data?.message?.summary);
          this2.processing = false;
          this2.$scope.closeThisDialog(false);
        });
    }
  }

  ChargeMailOrderRefillController.$inject = [
    '$rootScope',
    '$scope',
    '$timeout',
    '$interval',
    'toastr',
    'Orders',
    'Users',
    '$state',
    'ngDialog',
    'Utils',
    'RefillResponsesStoreStore',
    'FillsEndpoints',
  ];
  angular.module('pims').controller('ChargeMailOrderRefillController', ChargeMailOrderRefillController);
})();
